import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import AccountsModal from '../components/AccountsModal';
import './AccountsOffice.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AccountsOffice = () => {
  const [deals, setDeals] = useState([]);
  const [filteredDeals, setFilteredDeals] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchDeals();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      const filtered = deals.filter(deal => 
        deal.mouNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        deal.companyName?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredDeals(filtered);
    } else {
      setFilteredDeals(deals);
    }
  }, [searchQuery, deals]);

  const fetchDeals = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/accounts-deals`);
      setDeals(response.data);
      setFilteredDeals(response.data);
    } catch (error) {
      console.error('Error fetching deals:', error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (deal) => {
    setSelectedDeal(deal);
    setModalOpen(true);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="accounts-office">
      <motion.div
        className="accounts-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1>Accounts Office Portal</h1>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search by MOU Number (M1, M2, M3...)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </motion.div>

      <div className="deals-grid">
        {filteredDeals.map((deal, index) => (
          <motion.div
            key={deal.id}
            className="deal-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => openModal(deal)}
          >
            <div className="card-header">
              <h3>{deal.companyName}</h3>
              <span className="mou-badge">{deal.mouNumber}</span>
            </div>
            <div className="card-body">
              <div className="info-row">
                <span className="label">Student:</span>
                <span className="value">{deal.studentName}</span>
              </div>
              <div className="info-row">
                <span className="label">MOU Amount:</span>
                <span className="value">₹{deal.amount}</span>
              </div>
              <div className="info-row">
                <span className="label">Payment Amount:</span>
                <span className="value">₹{deal.paymentAmount || 'Pending'}</span>
              </div>
              <div className="info-row">
                <span className="label">Transaction ID:</span>
                <span className="value">{deal.paymentTransactionId || 'N/A'}</span>
              </div>
              <div className="status-badges">
                {deal.paymentVerified && (
                  <span className="badge verified">Payment Verified</span>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {filteredDeals.length === 0 && (
        <div className="empty-state">No deals found</div>
      )}

      <AccountsModal isOpen={modalOpen} onClose={() => setModalOpen(false)} deal={selectedDeal} />
    </div>
  );
};

export default AccountsOffice;
